"use client";

import { c as _c } from "react-compiler-runtime";
import { QueryClient, QueryClientProvider as TanstackQueryClientProvider } from "@tanstack/react-query";
import { ReactNode } from "react";
import { getErrorStatus, isAbortError } from "@/core/api/http-error.utils";

// Some browsers report navigator.onLine === false while online (VPNs, security agents); the
// default "online" mode then pauses every request forever, leaving a blank screen.
const QUERY_NETWORK_MODE = "offlineFirst";
export const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {
      networkMode: QUERY_NETWORK_MODE
    },
    queries: {
      networkMode: QUERY_NETWORK_MODE,
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      retry: (failureCount, error) => {
        if (isAbortError(error)) return false;
        if (failureCount >= 1) return false;
        const status = getErrorStatus(error);
        if (typeof status === "number") return status >= 500;
        return error instanceof TypeError;
      }
    }
  }
});
export function QueryClientProvider(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <TanstackQueryClientProvider client={queryClient}>{children}</TanstackQueryClientProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}